<template>
<b-row class="ot-main-panel no-gutters OTSettings">
    <b-col>
        <otif-vertical-nav id="nav-ecm-settings" header="ECM & RDBMS Dashboard">
            <otif-vertical-navItem to="/reports/ecmcrawlerexecutions">ECM Executions</otif-vertical-navItem>
            <otif-vertical-navItem to="/reports/ecmcrawlerreports">ECM Reports</otif-vertical-navItem>
            <otif-vertical-navItem to="/reports/rdbmscrawlerexecutions">RDBMS Executions</otif-vertical-navItem>
            <otif-vertical-navItem to="/reports/rdbmscrawlerreports">RDBMS Reports</otif-vertical-navItem>
        </otif-vertical-nav>
    </b-col>
    <b-col cols="12" md="9">
        <router-view></router-view>
    </b-col>
</b-row>
</template>

<script>

export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (!vm.$session.isAdmin) {
                vm.$router.push('/');
            }
        });
    }
}
</script>
